import { Flower2 } from "lucide-react";

const ITEMS = ["Guided Breathwork", "Somatic Movement", "Expressive Art", "Reflective Journaling", "Rest & Renewal"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-[#D9C3A3]/50 bg-[#F5F0E8] py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif text-xl italic text-[#262320]/80 sm:text-2xl">{item}</span>
                <Flower2 size={16} className="text-[#5E7D6A]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
